/** Shared stylus awareness across the per-page Fabric editors AND the
 * scroller-level gesture layer (pinch / pan). Once a pen (Apple Pencil etc.) is
 * seen, finger touches are treated as NAVIGATION (pan/zoom), never ink — which
 * is what lets a writer rest a palm, tap the pen, then pinch around with their
 * fingers to position the page. Module-level singleton so every page editor and
 * the gesture hook observe the same pen history within a session. */

const state = { seenPen: false, lastPenAt: 0, strokeActive: false };

/** A touch landing within this window of the last pen contact is almost
 * certainly the writing hand's palm, not an intentional gesture. */
export const PALM_WINDOW_MS = 2000;

export function markPen(): void {
  state.seenPen = true;
  state.lastPenAt = performance.now();
}

/** True once any pen has ever touched in this session. */
export function hasSeenPen(): boolean {
  return state.seenPen;
}

export function msSincePen(): number {
  return performance.now() - state.lastPenAt;
}

/** Set by the editor while a pen stroke is mid-draw: the gesture layer uses it
 * to ignore the resting palm WITHOUT blocking a deliberate finger pan made
 * between strokes (the bug this whole module fixes). */
export function setPenStrokeActive(active: boolean): void {
  state.strokeActive = active;
}

export function isPenStrokeActive(): boolean {
  return state.strokeActive;
}
